export const discountTypesList = [
  { id: 1, name: "percent", type: "Percent" },
  { id: 2, name: "amount", type: "Amount" },
];
